module.exports = require('./helpers/bundle-url').getBundleURL('3Bta7') + "logo-dark.eefe0b7f.svg";